import { render } from "./MessageModal.vue?vue&type=template&id=f60c3ce6"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__